import type { ReplayPlugin } from "@slot/client-engine";
import type { FeatureModeStore } from "./FeatureModeStore";

/** A feature entering clears the armed feature mode (the bought / selected mode has been consumed). */
export function createFeatureModePlugin(deps: { store: FeatureModeStore }): ReplayPlugin {
  return {
    name: "feature-mode",
    observer: {
      onFeatureState: async (event) => {
        if (event.eventContent.featureState?.featurePhase === "enter") deps.store.clear();
      },
    },
  };
}
